import { render, staticRenderFns } from "./carExhibitionDetail.vue?vue&type=template&id=c97e682a&scoped=true&lang=html"
import script from "./carExhibitionDetail.vue?vue&type=script&lang=js"
export * from "./carExhibitionDetail.vue?vue&type=script&lang=js"
import style0 from "./carExhibitionDetail.vue?vue&type=style&index=0&id=c97e682a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97e682a",
  null
  
)

export default component.exports